__turbopack_context__.v({
  "addToCartCTAWrapper": "ProductAddToCartWrapper-module-scss-module__MJpfhG__addToCartCTAWrapper",
});
